import axios from "axios";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";

const sitiDataUrl = process.env.VUE_APP_SITIDATA_AUTOCOMPLETE_URL;
const sitiDataToken = process.env.VUE_APP_SITIDATA_AUTOCOMPLETE_TOKEN;

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const getAddressOptions = async (address: string): Promise<any[]> => {
  try {
    const response = await axios.post(
      sitiDataUrl,
      { address },
      {
        headers: {
          Authorization: `Token ${sitiDataToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    logAnalyticsEvent(
      AnalyticEvents.CreditLine.SitiDataAutoCompleteOptionsShowed,
      "CC_Shipments",
      undefined,
      {
        provider: "sitiData",
        responseStatus: response.data?.data.hits,
      }
    );

    return response.data?.data.hits || [];
  } catch (error) {
    console.error("Error fetching address options:", error);
    throw error;
  }
};
